<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <form @submit.prevent="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <h1 class="is-title-header modal-card-title">
            {{ action }} Suppliers
          </h1>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <b-field label="Supplier ID" v-if="action !== 'Add'">
                <b-input
                  name="code"
                  maxlength="200"
                  v-model="form.code"
                  required
                  disabled
                />
              </b-field>
              <b-field label="Supplier Name">
                <b-input
                  name="name"
                  maxlength="200"
                  v-model="form.name"
                  required
                  :disabled="action === 'View'"
                />
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button
            slot="right"
            type="is-primary"
            native-type="submit"
            v-if="action != 'View'"
          >
            OK
          </b-button>
          <b-button slot="right" type="is-danger" @click="cancel">
            Cancel
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>
<script>
// @group Customers
export default {
  name: "SupplierForm",
  props: {
    action: {
      type: String,
      default: "Add"
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      form: {},
      isModalActive: false
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    submit() {
      this.$emit("confirm", this.form);
    }
  },

  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    editObjectName(newValue) {
      this.form = { ...newValue };
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
